module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.dda9a792.ttf";